module.exports = __webpack_public_path__ + "static/media/image_81.f9e9518e.png";